export enum EInvoiceAssuranceType {
  Decenal = 1,
  RcPro = 2,
}
